import { defaultState } from '@/enums/womenSignup'

export default () => ({
  ...defaultState
})
